import './styles.css';

export default function MovieInfoHeader(  { movie_data, watch_data } ) {
    return(
        <header className="header">
            <h2 className='movie-name'>{movie_data?.name || movie_data?.title}</h2>
            {(watch_data?.media_type === 'tv') &&
                <span className='show-span-info-movie'>
                    T{watch_data?.episode_details?.season_number} / E{watch_data?.episode_details?.episode_number}
                    {(watch_data?.episode_details?.name) && `: ${watch_data?.episode_details?.name}`}
                </span>
            }
        </header>
    )
}